module.exports = __webpack_public_path__ + "static/Jones-954dc4f9884914900c96a9b109ff8bcf.png";